import { useCompanies } from '../../hooks';
import { CompanyType } from '../../enums';
import { QuoteConversionRateFiltersProps } from './QuoteConversionRateFilters.props';
import { QuoteConversionRateFilters } from './QuoteConversionRateFilters.component';

export const AdminQuoteConversionRateFilters = (
  props: Omit<QuoteConversionRateFiltersProps, 'companies' | 'loadingCompanies'>
) => {
  const { list: companies, loading: loadingCompanies } = useCompanies({
    filters: [['type', '==', CompanyType.Customer]],
  });

  return (
    <QuoteConversionRateFilters
      {...props}
      companies={companies}
      loadingCompanies={loadingCompanies}
    />
  );
};
